<template lang="html">
  <div>
    <table class="table table-striped table-bordered table-hover no-footer lista-campeonatos">
      <thead>
        <tr>
          <th>#</th>
          <th>Nombre</th>
          <th>Fecha</th>
          <th>Rondas</th>
          <th>Ver</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="championship in championships">
          <td>{{ $index + 1}}</td>
          <td>{{ championship.name }}</td>
          <td>{{ championship.dates[0].date }}</td>
          <td>{{ championship.dates.length }}</td>
          <td>
            <a title="Ver Campeonato" @click="getChampionship(championship)"><span aria-hidden="true" class="glyphicon glyphicon-search"></span></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import configure from '../configure'
import * as actions from '../vuex/actions'

export default {
  vuex: {
    actions: actions
  },
  data() {
    return {
      championships: [],
      championship: null
    }
  },
  ready() {
    this.fetchChampionships()
  },
  methods: {
    fetchChampionships () {
      this.$progress.start()
      this.$http.get(
        configure.api_url + 'championships'
      ).then((response) => {
        this.championships = response.data
        this.$progress.finish()
      }, (error) => {

        this.$progress.failed()
      })
    },
    getChampionship (championship) {
      this.show_tabs = false
      this.$progress.start()
      this.$http.get(
        configure.api_url + 'championships/' + championship.id
      ).then((response) => {
        this.championship = response.data
        this.setChampionship(this.championship)
        this.$progress.finish()
        this.$router.go('/championship')
      }, (error) => {
        alert('Error getting championship')
        this.$progress.failed()
      })
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** ChampionshipsList.vue?513fc8aa
 **/